import React, { useState } from "react";
import styles from "./ErrorPage.module.css";
import UnicornIcon from "./../assets/unicorn.svg";
import ErrorIcon from "./../assets/404.svg";
import { tertiaryTextColor, fw500, titleXXL } from "../Global.module.css";
import { useHistory } from "react-router-dom";

export default function ErrorPage() {
	const [answer, setAnswer] = useState(false);
	const history = useHistory();
	const revealAnswer = () => {
		setAnswer(true);
	};
	const handleRoute = () => {
		history.replace("/");
	};
	return (
		<div className={styles.errorPage}>
			{!answer && (
				<>
					<img
						className={styles.icon}
						src={UnicornIcon}
						alt="Unicorn"
						width="180px"
						height="180px"
					/>
					<p
						className={`${tertiaryTextColor} ${fw500} ${titleXXL}  ${styles.message}`}
					>
						Do you know what is similar between an UNICORN and this
						URL?
					</p>
					<p className={styles.knowBtn} onClick={revealAnswer}>
						Answer
					</p>
				</>
			)}
			{answer && (
				<>
					<img
						className={styles.icon}
						src={ErrorIcon}
						alt="404"
						width="280px"
						height="280px"
					/>
					<p
						className={`${tertiaryTextColor} ${fw500} ${titleXXL} ${styles.message}`}
					>
						They both do not exists.
					</p>
					<p className={styles.knowBtn} onClick={handleRoute}>
						Home
					</p>
				</>
			)}
		</div>
	);
}
